var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { SubCollection, Collection, Field, Codable } from '@1amageek/ballcap';
import { Base } from '.';
import { StripeCustomer } from './entity/StripeCustomer';
import { TrialPayPerUse } from './entity/TrialPayPerUse';
import { TrialSubscription } from './entity/TrialSubscription';
import { Utils } from '../../../common/helper';
export class Clinic extends Base {
    constructor() {
        super(...arguments);
        // 支払い処理
        this.jobRewards = new Collection();
        // 修正依頼
        this.modificationRequests = new Collection();
    }
    static collectionReference() {
        return super.collectionReference().doc('v1').collection('clinics');
    }
    get isRegisteredStripeCustomer() {
        var _a;
        return Utils.isNotNull((_a = this.stripeCustomer) === null || _a === void 0 ? void 0 : _a.customerId);
    }
}
__decorate([
    Field,
    __metadata("design:type", String)
], Clinic.prototype, "clinicUserType", void 0);
__decorate([
    Field,
    __metadata("design:type", Number)
], Clinic.prototype, "planType", void 0);
__decorate([
    Field,
    __metadata("design:type", Number)
], Clinic.prototype, "prevPlanType", void 0);
__decorate([
    Field,
    __metadata("design:type", Number)
], Clinic.prototype, "paymentMethod", void 0);
__decorate([
    Field,
    __metadata("design:type", Number)
], Clinic.prototype, "jobRewardCount", void 0);
__decorate([
    Field,
    __metadata("design:type", Number)
], Clinic.prototype, "modificationRequestCount", void 0);
__decorate([
    Codable(StripeCustomer),
    Field,
    __metadata("design:type", StripeCustomer
    // サブスクリプションの試用利用の状態
    )
], Clinic.prototype, "stripeCustomer", void 0);
__decorate([
    Codable(TrialSubscription),
    Field,
    __metadata("design:type", TrialSubscription
    // 成果報酬プランの試用利用の状態
    )
], Clinic.prototype, "trialSubscription", void 0);
__decorate([
    Codable(TrialPayPerUse),
    Field,
    __metadata("design:type", TrialPayPerUse
    // 支払い処理
    )
], Clinic.prototype, "trialPayPerUse", void 0);
__decorate([
    SubCollection,
    __metadata("design:type", Collection)
], Clinic.prototype, "jobRewards", void 0);
__decorate([
    SubCollection,
    __metadata("design:type", Collection)
], Clinic.prototype, "modificationRequests", void 0);
